/* Zenzorama handlekurvskuff — 2026-08-02.
   Prinsipp: /cart.js er eneste sannhetskilde (spiller sammen med Bundler og
   andre apper som endrer kurven server-side). Skuffen leser, rendrer og
   sender endringer via Ajax Cart API — den rører aldri andres DOM. */
(function () {
  'use strict';
  var rot = document.getElementById('ZenzCartDrawer');
  var bakteppe = document.getElementById('ZenzCartBackdrop');
  if (!rot || !bakteppe) return;

  var body = rot.querySelector('[data-zcd-linjer]');
  var notatBoks = rot.querySelector('[data-zcd-notat]');
  var antallEl = rot.querySelector('[data-zcd-antall]');
  var sumEl = rot.querySelector('[data-zcd-sum]');
  var sparerRad = rot.querySelector('[data-zcd-sparer-rad]');
  var sparerEl = rot.querySelector('[data-zcd-sparer]');
  var ftEl = rot.querySelector('[data-zcd-ft]');
  var passerEl = rot.querySelector('[data-zcd-passer]');
  var passerListe = rot.querySelector('[data-zcd-passer-liste]');
  var passerCache = {};
  var passerLopenr = 0;
  var delEl = rot.querySelector('[data-zcd-del]');
  var sendEl = rot.querySelector('[data-zcd-send]');
  var kopierEl = rot.querySelector('[data-zcd-kopier]');
  var delStatus = rot.querySelector('[data-zcd-del-status]');
  var fraktEl = rot.querySelector('[data-zcd-frakt]');
  var vektEl = rot.querySelector('[data-zcd-vekt]');
  var sisteLenke = '';
  var kopierTidtaker = null;
  var sistFokus = null;
  var travel = false;

  function kr(oere) {
    var v = oere / 100;
    var s = v.toLocaleString('nb-NO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return s.replace(/,00$/, '') + ' kr';
  }
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
  function bildeUrl(url, w) {
    if (!url) return null;
    try { var u = new URL(url, location.origin); u.searchParams.set('width', w); return u.toString(); }
    catch (e) { return url; }
  }

  function hentKurv() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function render(kurv) {
    var n = kurv.item_count;
    document.querySelectorAll('[data-header-cart-count],[data-cart-count]').forEach(function (el) { el.textContent = n; });
    antallEl.textContent = n === 1 ? '1 vare' : n + ' varer';

    if (notatBoks) {
      notatBoks.hidden = !kurv.items.length;
      /* Naar minst en linje har «Farge» som property, skal notatet ikke be om fargekode (zenz-cart-note) */
      var harFarge = kurv.items.some(function (it) { return it.properties && it.properties['Farge']; });
      Array.prototype.forEach.call(notatBoks.querySelectorAll('.zenz-notat'), function (n) { n.toggleAttribute('data-har-farge', harFarge); });
    }
    var notatFelt = rot.querySelector('[data-zenz-note]');
    if (notatFelt && document.activeElement !== notatFelt) notatFelt.value = kurv.note || '';
    if (!kurv.items.length) {
      body.innerHTML = '<div class="zcd__tom"><h3>Handlekurven er tom</h3><p>Verktøy, systemer og materialer venter i butikken.</p><button type="button" class="zcd__btn zcd__btn--outline" data-zcd-lukk style="width:auto">Fortsett å handle</button></div>';
      ftEl.hidden = true;
      if (delEl) delEl.hidden = true;
      if (passerEl) passerEl.hidden = true;
      return;
    }
    ftEl.hidden = false;

    var spart = 0;
    body.innerHTML = kurv.items.map(function (item) {
      var linjeSpart = item.original_line_price - item.final_line_price;
      if (linjeSpart > 0) spart += linjeSpart;
      var meta = [];
      if (item.variant_title && item.variant_title !== 'Default Title') meta.push(esc(item.variant_title));
      if (item.vendor) meta.push(esc(item.vendor));
      /* Feltona Flis (leveranse 3): enhetspris kr/m² og totalt antall m² paa linjen. */
      if (item.unit_price_measurement && item.unit_price_measurement.reference_unit === 'm2' && item.unit_price) {
        var m2 = parseFloat(item.unit_price_measurement.quantity_value) * item.quantity;
        meta.push(kr(Math.round(item.unit_price / 100) * 100) + '/m² · ' + String(Math.round(m2 * 100) / 100).replace('.', ',') + ' m²');
      }
      /* Leveranse 2 prosjektvelger (2026-09-06): line item properties (Farge, Struktur, Prosjekt) vises paa linjen.
         Noekler med _-prefiks er interne (Shopify-konvensjon) og skjules. */
      var props = item.properties || {}, propHtml = '';
      Object.keys(props).forEach(function (k) {
        if (k.charAt(0) === '_' || props[k] == null || props[k] === '') return;
        propHtml += '<span class="zcd__prop"><strong>' + esc(k) + ':</strong> ' + esc(props[k]) + '</span>';
      });
      var img = bildeUrl(item.image, 168);
      return '<div class="zcd__linje" data-key="' + esc(item.key) + '">' +
        '<span class="zcd__bilde">' + (img ? '<img src="' + img + '" alt="" loading="lazy" width="84" height="84">' : '') + '</span>' +
        '<div>' +
          '<a class="zcd__navn" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
          (meta.length ? '<p class="zcd__meta">' + meta.join(' · ') + '</p>' : '') +
          (kanHaInnhold(item) ? innholdListe(item) : '') +
          (propHtml ? '<p class="zcd__meta zcd__props">' + propHtml + '</p>' : '') +
          '<div class="zcd__rad2">' +
            '<span class="zcd__qty" aria-label="Antall for ' + esc(item.product_title) + '">' +
              '<button type="button" data-zcd-qty="-1" aria-label="Færre"' + (item.quantity <= 1 ? ' disabled' : '') + '>&minus;</button>' +
              '<span aria-live="polite">' + item.quantity + '</span>' +
              '<button type="button" data-zcd-qty="1" aria-label="Flere">+</button>' +
            '</span>' +
            '<span class="zcd__pris">' +
              (linjeSpart > 0 ? '<span class="zcd__for">' + kr(item.original_line_price) + '</span>' : '') +
              '<strong>' + kr(item.final_line_price) + '</strong>' +
              (linjeSpart > 0 ? '<span class="zcd__sparer">Du sparer ' + kr(linjeSpart) + '</span>' : '') +
            '</span>' +
          '</div>' +
          '<button type="button" class="zcd__fjern" data-zcd-fjern>Fjern</button>' +
        '</div>' +
      '</div>';
    }).join('');

    sumEl.textContent = kr(kurv.total_price);
    sparerRad.hidden = spart <= 0;
    if (spart > 0) sparerEl.textContent = kr(spart);
    oppdaterDeling(kurv);
    oppdaterPasser(kurv);
    oppdaterVekt(kurv);
    oppdaterPakkeinnhold(kurv);
  }

  /* ---------- Pakkeinnhold på bundle-linjer (Stian 2026-10-13) ----------
     /cart.js sier has_components: true på en bundle-linje, uten komponentene, og /cart/change.js (antall +/-)
     mangler feltet helt. Komponentene hentes derfor fra item_components i Liquid via
     sections/zenz-kurv-pakkeinnhold.liquid (Section Rendering API), med samme formulering som pakkevelgeren
     («4 × Cretezenz Base 12 kg»). Hurtiglager per linjenøkkel + antall; vanlige varer lagres som tom liste,
     så de ikke hentes på nytt. Ukjent has_components (change.js) = spør seksjonen. */
  var innholdCache = {};
  function kanHaInnhold(item) {
    if (item.has_components === false) return false;
    var liste = innholdCache[item.key + '|' + item.quantity];
    return !(liste && !liste.length);
  }
  function innholdListe(item) {
    var liste = innholdCache[item.key + '|' + item.quantity];
    var harListe = !!(liste && liste.length);
    return '<ul class="zcd__innhold" data-zcd-innhold="' + esc(item.key) + '"' + (harListe ? '' : ' hidden') + ' aria-label="Pakken inneholder">' +
      (harListe ? liste.map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('') : '') + '</ul>';
  }
  function oppdaterPakkeinnhold(kurv) {
    var mangler = kurv.items.some(function (it) { return it.has_components !== false && innholdCache[it.key + '|' + it.quantity] === undefined; });
    if (!mangler) return;
    var rotUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(rotUrl + '?sections=zenz-kurv-pakkeinnhold', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (svar) {
        var html = svar && svar['zenz-kurv-pakkeinnhold'];
        if (!html) return;
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var node = tmp.querySelector('[data-zcd-pakkeinnhold]');
        if (!node) return;
        var data = JSON.parse(node.textContent || '{}');
        Object.keys(data).forEach(function (k) { if (data[k] && data[k].innhold) innholdCache[k + '|' + data[k].antall] = data[k].innhold; });
        kurv.items.forEach(function (it) { if (!data[it.key] && innholdCache[it.key + '|' + it.quantity] === undefined) innholdCache[it.key + '|' + it.quantity] = []; });
        Array.prototype.forEach.call(body.querySelectorAll('[data-zcd-innhold]'), function (ul) {
          var linje = ul.closest('[data-key]');
          var antallEl = linje && linje.querySelector('.zcd__qty [aria-live]');
          var liste = linje && innholdCache[linje.getAttribute('data-key') + '|' + (antallEl ? antallEl.textContent.trim() : '')];
          if (!liste || !liste.length) return;
          ul.innerHTML = liste.map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('');
          ul.hidden = false;
        });
      })
      .catch(function () {});
  }

  /* ---------- Vektvarsel (frakt for tunge ordrer, L2, 2026-10-10) ----------
     Over «Stykkgods fra (kg)» viser kassen bare stykkgods; over «Frakttilbud fra (kg)» bare Bring Stykkgods.
     Varselet erstatter den dempede fraktlinjen under totalen. Grenser og tekster kommer fra data-attributtene. */
  function oppdaterVekt(kurv) {
    if (!vektEl || !fraktEl) return;
    var d = vektEl.dataset;
    var gram = kurv.total_weight || 0;
    var grense = parseInt(d.grense, 10) || 35000;
    var tilbud = parseInt(d.tilbud, 10) || 100000;
    if (!kurv.item_count || gram <= grense) { vektEl.hidden = true; fraktEl.hidden = false; return; }
    var kg = Math.round(gram / 1000).toLocaleString('nb-NO');
    /* Leverandører med plassholdervekt (temainnstilling «Skjul vekt for leverandører»): ingen vekttall i teksten */
    var skjul = (d.skjul || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var utenTall = kurv.items.some(function (it) { return skjul.indexOf(it.vendor) !== -1; });
    var lenke = ' <a class="zcd__lenke" href="' + esc(d.url) + '">' + esc(d.tLenke) + '</a>. ';
    var html;
    if (utenTall) {
      html = gram > tilbud
        ? esc(d.tUtenVekt) + ' ' + esc(d.tTilbud) + lenke + esc(d.tHenting)
        : esc(d.tUtenVekt) + ' ' + esc(d.tKasse) + ' ' + esc(d.tHenting);
    } else {
      var vekt = esc(d.tVekt).replace('{vekt}', '<strong>' + kg + ' kg</strong>');
      html = gram > tilbud
        ? vekt + '. ' + esc(d.tTilbud) + lenke + esc(d.tHenting)
        : vekt + ' ' + esc(d.tStykkgods) + ' ' + esc(d.tHenting);
    }
    vektEl.innerHTML = '<svg class="zcd__vekt-ic" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 16V6a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v10M15 9h3.6a1 1 0 0 1 .8.4L21.8 13a1 1 0 0 1 .2.6V16"/><path d="M3 16h1.2M10.8 16h4.4M20.8 16H21"/><circle cx="7" cy="17.5" r="1.9"/><circle cx="18" cy="17.5" r="1.9"/></svg><span>' + html + '</span>';
    vektEl.dataset.niva = gram > tilbud ? 'tilbud' : 'stykkgods';
    vektEl.hidden = false;
    fraktEl.hidden = true;
  }

  /* ---------- Passer til (L4, 2026-10-10) ----------
     Komplementære produkter fra Search & Discovery, per vare i kurven, via Section Rendering API
     (/products/<handle>?section_id=zenz-passer-til-data). Maks 3 i raden, delt rettferdig mellom varene i kurven,
     ingen duplikater, ingen varer som allerede ligger i kurven, ingen utsolgte. Skjult når tom. */
  var PASSER_MAKS = 3, PASSER_KILDER = 4;

  function hentPasserFor(handle) {
    if (!passerCache[handle]) {
      passerCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '?section_id=zenz-passer-til-data', { headers: { Accept: 'text/html' } })
        .then(function (r) { if (!r.ok) throw new Error('passer ' + r.status); return r.text(); })
        .then(function (html) {
          var el = new DOMParser().parseFromString(html, 'text/html').querySelector('script[data-zpt-data]');
          var liste = el ? JSON.parse(el.textContent) : [];
          return Array.isArray(liste) ? liste : [];
        })
        .catch(function () { delete passerCache[handle]; return []; });
    }
    return passerCache[handle];
  }

  function velgPasser(lister, iKurv) {
    var sett = {}, ut = [];
    var lengste = lister.reduce(function (m, l) { return Math.max(m, l.length); }, 0);
    for (var i = 0; i < lengste && ut.length < PASSER_MAKS; i++) {
      for (var k = 0; k < lister.length && ut.length < PASSER_MAKS; k++) {
        var p = lister[k][i];
        if (!p || iKurv[p.id] || sett[p.id] || !p.tilgjengelig) continue;
        sett[p.id] = true; ut.push(p);
      }
    }
    return ut;
  }

  function oppdaterPasser(kurv) {
    if (!passerEl || !passerListe) return;
    var lopenr = ++passerLopenr;
    var iKurv = {}, handles = [];
    kurv.items.forEach(function (it) {
      iKurv[it.product_id] = true;
      if (it.handle && handles.indexOf(it.handle) < 0) handles.push(it.handle);
    });
    Promise.all(handles.slice(0, PASSER_KILDER).map(hentPasserFor)).then(function (lister) {
      if (lopenr !== passerLopenr) return; // nyere kurv er alt på vei
      var valgt = velgPasser(lister, iKurv);
      if (!valgt.length) { passerEl.hidden = true; passerListe.innerHTML = ''; return; }
      var d = passerEl.dataset;
      passerListe.innerHTML = valgt.map(function (p) {
        var bilde = p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy" width="52" height="52">' : '';
        var pris = (p.fra ? esc(d.fra) + ' ' : '') + esc(p.price);
        var knapp = p.varianter > 1
          ? '<a class="zcd__pt-knapp zcd__pt-knapp--lenke" href="' + esc(p.url) + '">' + esc(d.velg) + '</a>'
          : '<button type="button" class="zcd__pt-knapp" data-zcd-pt-legg data-variant="' + esc(p.variantId) + '" aria-label="' + esc(d.legg) + ': ' + esc(p.title) + '">' + esc(d.legg) + '</button>';
        return '<div class="zcd__pt"><a class="zcd__pt-bilde" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + bilde + '</a>' +
          '<div class="zcd__pt-tekst"><a class="zcd__pt-navn" href="' + esc(p.url) + '">' + esc(p.title) + '</a><span class="zcd__pt-pris">' + pris + '</span></div>' + knapp + '</div>';
      }).join('');
      passerEl.hidden = false;
    });
  }

  function leggPasser(knapp) {
    if (travel || knapp.getAttribute('aria-busy') === 'true') return;
    travel = true; knapp.setAttribute('aria-busy', 'true'); knapp.textContent = passerEl.dataset.legger;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(knapp.getAttribute('data-variant')), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return hentKurv(); })
      .then(render)
      .catch(function () { knapp.removeAttribute('aria-busy'); knapp.textContent = passerEl.dataset.legg; })
      .finally(function () { travel = false; });
  }

  /* ---------- Del handlekurven (2026-10-10) ----------
     Lenke: /cart/<variant>:<antall>,...?storefront=true (åpner handlekurven, ikke kassen).
     Shopify tar med line item properties i permalenker bare for første vare, som Base64-kodet JSON
     i ?properties= (målt mot zenzorama.no 2026-10-10: Base64 virker, rå JSON gjør kurven tom).
     Derfor står Farge, Struktur og Prosjekt for alle linjer også i meldingsteksten. Kurvnotatet følger med i ?note=, med egenskapene for linje 2+ lagt etter. */
  var MAKS_MAILTO = 1900; // trygg lengde for e-postprogrammer (Outlook kutter rundt 2000)

  function synligeEgenskaper(item) {
    var ut = [], p = item.properties || {};
    Object.keys(p).forEach(function (k) {
      if (k.charAt(0) === '_' || p[k] == null || p[k] === '') return;
      ut.push([k, String(p[k])]);
    });
    return ut;
  }

  function base64Utf8(tekst) {
    return btoa(unescape(encodeURIComponent(tekst)));
  }

  function byggLenke(kurv) {
    var items = kurv.items.slice();
    /* Permalenken bærer egenskaper bare for første vare: la første linje med egenskaper komme først. */
    var med = -1;
    for (var i = 0; i < items.length; i++) { if (synligeEgenskaper(items[i]).length) { med = i; break; } }
    if (med > 0) items.unshift(items.splice(med, 1)[0]);
    var linjer = items.map(function (it) { return it.variant_id + ':' + it.quantity; }).join(',');
    var url = location.origin + '/cart/' + linjer + '?storefront=true';
    var egenskaper = synligeEgenskaper(items[0]);
    if (egenskaper.length) {
      var obj = {};
      egenskaper.forEach(function (e) { obj[e[0]] = e[1]; });
      url += '&properties=' + encodeURIComponent(base64Utf8(JSON.stringify(obj)));
    }
    var notat = byggNotat(kurv, items);
    if (notat) url += '&note=' + encodeURIComponent(notat);
    return url;
  }

  /* Egenskaper for linje 2 og utover får ikke plass i permalenken. De legges kompakt i kurvnotatet,
     etter kundens eget notat (som står først og aldri skrives over). Identiske egenskaper slås sammen:
     «Valg fra delt handlekurv: Primer Z 1 kg, Pensel (Farge: Sand, Prosjekt: 12 m²)». */
  function byggNotat(kurv, items) {
    var eget = kurv.note ? String(kurv.note).trim() : '';
    var grupper = [], indeks = {};
    items.slice(1).forEach(function (it) {
      var e = synligeEgenskaper(it);
      if (!e.length) return;
      var nokkel = e.map(function (x) { return x[0] + '=' + x[1]; }).join('|');
      if (!(nokkel in indeks)) { indeks[nokkel] = grupper.length; grupper.push({ navn: [], e: e }); }
      grupper[indeks[nokkel]].navn.push(it.product_title);
    });
    if (!grupper.length) return eget;
    var valg = 'Valg fra delt handlekurv: ' + grupper.map(function (g) {
      return g.navn.join(', ') + ' (' + g.e.map(function (x) { return x[0] + ': ' + x[1]; }).join(', ') + ')';
    }).join('; ');
    return eget ? eget + '\n' + valg : valg;
  }

  function byggTekst(kurv, lenke, niva) {
    var d = delEl.dataset, L = [d.intro, ''];
    if (niva < 2) {
      kurv.items.forEach(function (it) {
        var navn = it.product_title + (it.variant_title && it.variant_title !== 'Default Title' && it.product_title.indexOf(it.variant_title) < 0 ? ' - ' + it.variant_title : '');
        var e = synligeEgenskaper(it);
        if (niva === 0) {
          L.push(it.quantity + ' ' + d.stk + ' ' + navn);
          e.forEach(function (x) { L.push(x[0] + ': ' + x[1]); });
          L.push('');
        } else {
          L.push(it.quantity + ' ' + d.stk + ' ' + navn + (e.length ? ' (' + e.map(function (x) { return x[0] + ': ' + x[1]; }).join(', ') + ')' : ''));
        }
      });
      if (niva === 1) L.push('');
    }
    L.push(d.delsum + ': ' + kr(kurv.total_price) + ' (' + String(d.mva).replace(/\.$/, '').toLowerCase() + ')');
    if (kurv.note && String(kurv.note).trim()) L.push(d.instruks + ': ' + String(kurv.note).trim());
    L.push('', d.apne, lenke);
    return L.join('\r\n');
  }

  function byggMailto(kurv, lenke) {
    var d = delEl.dataset;
    var til = d.epost ? encodeURIComponent(d.epost).replace(/%40/g, '@') : '';
    var href = '';
    for (var niva = 0; niva < 3; niva++) {
      href = 'mailto:' + til + '?subject=' + encodeURIComponent(d.emne) + '&body=' + encodeURIComponent(byggTekst(kurv, lenke, niva));
      if (href.length <= MAKS_MAILTO) break;
    }
    return href;
  }

  function oppdaterDeling(kurv) {
    if (!delEl || !sendEl || !kurv.items.length) return;
    sisteLenke = byggLenke(kurv);
    sendEl.setAttribute('href', byggMailto(kurv, sisteLenke));
    delEl.hidden = false;
  }

  function sporing(metode) {
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'kurv_delt', metode: metode }); } catch (e) { /* ignorer */ }
  }

  function kopier() {
    if (!sisteLenke) return;
    var ferdig = function () {
      var tekst = delEl.dataset.kopiert;
      kopierEl.textContent = tekst;
      if (delStatus) delStatus.textContent = tekst;
      clearTimeout(kopierTidtaker);
      kopierTidtaker = setTimeout(function () {
        kopierEl.textContent = kopierEl.getAttribute('data-tekst');
        if (delStatus) delStatus.textContent = '';
      }, 2200);
      sporing('kopier');
    };
    var reserve = function () {
      var t = document.createElement('textarea');
      t.value = sisteLenke; t.setAttribute('readonly', ''); t.style.cssText = 'position:fixed;top:0;left:0;opacity:0';
      rot.appendChild(t); t.select();
      try { if (document.execCommand('copy')) ferdig(); } catch (e) { /* ignorer */ }
      rot.removeChild(t);
      kopierEl.focus();
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(sisteLenke).then(ferdig, reserve);
    else reserve();
  }

  function oppdater() { return hentKurv().then(render); }

  function endre(key, quantity) {
    if (travel) return;
    travel = true; rot.setAttribute('aria-busy', 'true');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); })
      .then(render)
      .catch(function () { return oppdater(); })
      .finally(function () { travel = false; rot.removeAttribute('aria-busy'); });
  }

  function vis() {
    rot.classList.add('is-open'); bakteppe.classList.add('is-open');
    rot.setAttribute('aria-hidden', 'false');
    rot.removeAttribute('inert');
    document.documentElement.style.overflow = 'hidden';
    var lukk = rot.querySelector('.zcd__lukk'); if (lukk) lukk.focus();
  }
  function aapne() {
    sistFokus = document.activeElement;
    oppdater().then(vis);
  }
  /* Leveranse 3 (2026-09-05): naar produktsiden allerede har kurven fra /cart.js,
     rendres og aapnes skuffen umiddelbart - ingen ekstra rundtur foerst. */
  function aapneMed(kurv) {
    sistFokus = document.activeElement;
    render(kurv);
    vis();
  }
  function lukk() {
    rot.classList.remove('is-open'); bakteppe.classList.remove('is-open');
    rot.setAttribute('aria-hidden', 'true');
    rot.setAttribute('inert', '');
    document.documentElement.style.overflow = '';
    if (sistFokus && sistFokus.focus) sistFokus.focus();
  }

  /* Hendelser */
  rot.addEventListener('click', function (e) {
    var t;
    if (e.target.closest('[data-zcd-lukk]')) { lukk(); return; }
    if (e.target.closest('[data-zcd-kopier]')) { kopier(); return; }
    if ((t = e.target.closest('[data-zcd-pt-legg]'))) { leggPasser(t); return; }
    if (e.target.closest('[data-zcd-send]')) { sporing('epost'); return; }
    if ((t = e.target.closest('[data-zcd-qty]'))) {
      var linje = t.closest('[data-key]');
      var n = parseInt(linje.querySelector('.zcd__qty span').textContent, 10) + parseInt(t.dataset.zcdQty, 10);
      endre(linje.dataset.key, Math.max(0, n)); return;
    }
    if ((t = e.target.closest('[data-zcd-fjern]'))) {
      endre(t.closest('[data-key]').dataset.key, 0); return;
    }
  });
  bakteppe.addEventListener('click', lukk);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && rot.classList.contains('is-open')) lukk();
  });
  rot.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !rot.classList.contains('is-open')) return;
    var f = Array.prototype.filter.call(rot.querySelectorAll('button, [href], input'), function (x) { return !x.disabled && x.offsetParent; });
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { f[f.length - 1].focus(); e.preventDefault(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { f[0].focus(); e.preventDefault(); }
  });

  /* Åpning: kurvlenkene i headeren (progressivt — uten JS er de vanlige lenker til /cart).
     På selve /cart-siden beholdes lenken som side-navigasjon. */
  if (!/^\/cart\/?$/.test(location.pathname)) {
    document.querySelectorAll('.zh-topbar__cart, .zh-mobile-cart').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); aapne(); });
    });
  }
  /* Produktsidens «Legg i handlekurv» varsler oss */
  document.addEventListener('zenz:cart:added', function (e) {
    var kurv = e && e.detail && e.detail.cart;
    if (kurv && kurv.items) aapneMed(kurv); else aapne();
  });

  window.ZenzCartDrawer = { open: aapne, close: lukk, refresh: oppdater };
})();
